import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import NavBar from './NavBar';

export default class Popup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   * @param {NavBar} navbar
   */
  constructor(scene, navbar) {
    super(scene);

    this.navbar = navbar;

    this.shader = null;
    this.bg = null;
    this.bgCont = null;
    this.cancel = null;
    this.home = null;

    this.setup();
  }

  setup() {
    this.createShade();
    this.createButtons();
  }

  createShade () {
    this.shader = this.scene.add.rectangle(0,0, this.scene.scale.width, this.scene.scale.height,0x000000).setOrigin(0);
    this.shader.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.shader, 500, { alpha: 0.65 }, Phaser.Math.Easing.Linear);
  }

  createButtons () {
    this.bgCont = this.scene.add.container(this.scene.scale.width / 2, this.scene.scale.height / 2);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._ConfirmPopUp, this.bgCont);

    this.cancel = ABCyaPhaser.Images.addImage(this.bg.width / 4 - 20, this.bg.height / 4 - 20, UIAssetKeys._ConfirmPopUp_Cancel, this.bgCont);

    this.home = ABCyaPhaser.Images.addImage(-this.bg.width / 4 + 20, this.bg.height / 4 - 20, UIAssetKeys._ConfirmPopUp_Yes, this.bgCont);

    this.bgCont.setScale(0);

    ABCyaPhaser.Tweens.addTween(this.bgCont, 1000, { scale: 1, delay: 200 }, Phaser.Math.Easing.Back.Out, () => {
      this.enableButtons();
    });
  }

  enableButtons () {
    this.cancel.setInteractive({ useHandCursor: true });
    this.cancel.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.navbar.resumeGame, this.navbar);

    this.home.setInteractive({ useHandCursor: true });
    this.home.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.navbar.goHome, this.navbar);
  }

  cleanUp () {
    this.cancel.disableInteractive();
    this.home.disableInteractive();

    this.shader.destroy();
    this.bg.destroy();
    this.cancel.destroy();
    this.home.destroy();
    this.bgCont.destroy();
  }
}